/* @flow */

import * as React from 'react';

import { computed, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';

import CentralForm from 'components/CentralForm/CentralForm';
import AutoCompleteModel from 'models/forms/AutoCompleteModel';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import UserStore from 'stores/UserStore';
import { AccountModel } from 'models/AccountModels';
import { autoCompleteCountries } from 'api/forms';

import { makeFields, userDetails } from './setupUserDetailsForm';
import ElectroTextField from '../components/inputs/ElectroTextField/ElectroTextField';
import ElectroSelect from '../components/inputs/ElectroSelect/ElectroSelect';

type InjectedProps = {
  userStore: UserStore,
  accountModel: AccountModel,
} & TranslatorProps;

@translate()
@inject('accountModel', 'userStore')
@observer
export default class UserDetailsForm extends ComponentWithInjectedProps<{}, {}, InjectedProps> {
  @observable localState = {
    formIsLoading: false,
    showResponseMessage: false,
    responseMessage: '',
  };

  @computed get form(): Object {
    const { t } = this.props;
    const fields = makeFields(t);

    return userDetails(fields, this.localState, t);
  }

  render() {
    const {
      t,
      userStore: { isReadOnly },
    } = this.props;

    const form = this.form;

    const countryModel = new AutoCompleteModel(autoCompleteCountries);

    return (
      <React.Fragment>
        <CentralForm>
          <form>
            <h1>
              {t('general:accounts.welcome', { companyName: process.env.REACT_APP_COMPANY_NAME })}
            </h1>
            <p>{t('general:accounts.messages.verification')}</p>
            <h2>{t('general:accounts.step_1')}</h2>
            <h3>{t('general:accounts.additional_details')}</h3>
            <ElectroTextField field={form.$('additionalInfo.companyName')} />
            <ElectroTextField field={form.$('additionalInfo.contactPhoneNo')} />
            <ElectroSelect
              field={form.$('additionalInfo.country')}
              model={countryModel}
              valueKey="id"
              simpleValue={true}
            />
            <ElectroTextField field={form.$('additionalInfo.stateCountryProvince')} />
          </form>
          {/* <FormControls form={form} buttonText="Continue" /> */}
          <Button
            color="primary"
            variant="contained"
            onClick={form && form.onSubmit}
            disabled={isReadOnly}
          >
            {t('general:actions.continue')}
          </Button>
        </CentralForm>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.localState.showResponseMessage}
          onClose={() => {
            this.localState.showResponseMessage = false;
          }}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">{this.localState.responseMessage}</span>}
        />
      </React.Fragment>
    );
  }
}
